export const COLOR_HEX_CODE_REGEXP = new RegExp("^#[0-9A-F]{6}$", "i");

export const isValidHexCode = (colorHexCode) => COLOR_HEX_CODE_REGEXP.test(colorHexCode);
